import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const ItalicIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M19 4H10M14 20H5M15 4L9 20"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
);

ItalicIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(ItalicIcon);
